import { Injectable, signal, computed } from '@angular/core';

/**
 * Loader global tipo overlay para transiciones de página y operaciones
 * que afectan al layout completo. Los uploads de archivos NO deben usar
 * este servicio; cada slot de archivo tiene su propio indicador local.
 *
 * La visibilidad se controla con contadores para soportar múltiples
 * disparadores concurrentes (p.ej. guards + route resolvers).
 */
@Injectable({ providedIn: 'root' })
export class GlobalLoaderService {
  private readonly activeCount = signal(0);
  private readonly labelSignal = signal('');

  readonly visible = computed(() => this.activeCount() > 0);
  readonly label = computed(() => this.labelSignal());

  show(label = ''): void {
    if (label) this.labelSignal.set(label);
    this.activeCount.update(n => n + 1);
  }

  hide(): void {
    this.activeCount.update(n => Math.max(0, n - 1));
    if (this.activeCount() === 0) {
      this.labelSignal.set('');
    }
  }

  /** Forzar cierre total (útil en errores inesperados o logout). */
  reset(): void {
    this.activeCount.set(0);
    this.labelSignal.set('');
  }
}
